import AccountSetupPage from "@/pages/AccountSetupPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/setup-account")({
  component: AccountSetupPage,
});
